import hard_skills from "../../data/projects/enums/hard_skills";
import BaseFilter from "./BaseFilter";

interface HardSkillsFilterProps {
  pickedOptions: string[];
  setPickedOptions: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  displayColumn?: boolean;
  title?: string;
  filterKey?: string;
  maxDisplayOptions?: number;
  isAdd?: boolean;
}

export default function HardSkillsFilter({
  pickedOptions,
  setPickedOptions,
  show,
  setShow,
  displayColumn = true,
  title = "Target Roles",
  filterKey = "hardSkills",
  maxDisplayOptions,
  isAdd,
}: HardSkillsFilterProps & { title?: string }) {
  return (
    <BaseFilter
      pickedOptions={pickedOptions}
      setPickedOptions={setPickedOptions}
      show={show}
      setShow={setShow}
      displayColumn={displayColumn}
      title={title}
      filterKey={filterKey}
      originalOptions={hard_skills}
      filterType="hardSkills"
      showProposeButton={true}
      maxDisplayOptions={maxDisplayOptions}
      isAdd={isAdd}
    />
  );
}
